module.exports = __webpack_public_path__ + "static/media/feedback-icon.e8bf877e.png";